<div *ngIf="globals.storeSettings && globals.userIsAce()">
    <mat-tab-group (selectedTabChange)="cloneTabActive = $event.tab === cloneTab">
        <mat-tab [label]="'Generellt' | translate">
            <br />
            <h3>{{ 'Generellt' | translate }}</h3>
            <div class="row">
                <div class="col-4">
                    <mat-form-field class="fullwidth">
                        <label>{{ 'Namn' | translate }}</label>
                        <input matInput type="text" [(ngModel)]="globals.storeSettings.name" />
                    </mat-form-field>
                </div>
                <div class="col-4">
                    <mat-form-field class="fullwidth">
                        <label>{{ 'Access Code' | translate }}</label>
                        <input matInput type="text" [(ngModel)]="globals.storeSettings.accessCode" />
                    </mat-form-field>
                </div>
                <div class="col-4">
                    <mat-form-field>
                        <label>{{ 'Platform' | translate }}</label>
                        <mat-select [(ngModel)]="globals.storeSettings.platform">
                            <mat-option [value]="'woocommerce'">woocommerce</mat-option>
                            <mat-option [value]="'shopify'">shopify</mat-option>
                            <mat-option [value]="'fyndiq'">fyndiq</mat-option>
                            <mat-option [value]="'order-gateway'">{{ 'order-gateway' | translate }}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-4">
                    <mat-form-field>
                        <label>{{ 'Type' | translate }}</label>
                        <mat-select [(ngModel)]="globals.storeSettings.type">
                            <mat-option [value]="'ace'">ace</mat-option>
                            <mat-option [value]="'partner'">partner</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-4">
                    <mat-checkbox [(ngModel)]="globals.storeSettings.disabled">{{ 'Inaktiverad' | translate }}</mat-checkbox>
                </div>
                <div class="col-4">
                    <mat-form-field class="fullwidth">
                        <label>{{ 'Order Number Prefix' | translate }}</label>
                        <input matInput type="text" [(ngModel)]="globals.storeSettings.orderNumberPrefix" />
                    </mat-form-field>
                </div>
                <div class="col-4">
                    <mat-form-field class="fullwidth">
                        <label>{{ 'Admin Email' | translate }}</label>
                        <input matInput type="text" [(ngModel)]="globals.storeSettings.adminEmail" />
                    </mat-form-field>
                </div>
                <div class="col-4">
                    <mat-form-field class="fullwidth">
                        <label>{{ 'Custom Gateway Domain' | translate }}</label>
                        <input matInput type="text" [(ngModel)]="globals.storeSettings.customOrderGatewayDomain" />
                    </mat-form-field>
                </div>
                <div class="col-4">
                    <mat-checkbox [(ngModel)]="globals.storeSettings.onboardingPending">{{ 'Onboarding Pending' | translate }}</mat-checkbox>
                </div>
            </div>
            <div class="row">
                <div class="col-4">
                    <mat-form-field class="fullwidth">
                        <label>{{ 'Varumärke' | translate }}</label>
                        <input matInput type="text" [(ngModel)]="globals.storeSettings.brandName" />
                    </mat-form-field>
                </div>
                <div class="col-4">
                    <mat-form-field class="fullwidth">
                        <label>{{ 'Epost' | translate }}</label>
                        <input matInput type="text" [(ngModel)]="globals.storeSettings.email" />
                    </mat-form-field>
                </div>
                <div class="col-4">
                    <mat-checkbox [(ngModel)]="globals.storeSettings.sandbox">{{ 'Sandbox' | translate }}</mat-checkbox>
                </div>
                <div class="col-4">
                    <mat-checkbox [(ngModel)]="globals.storeSettings.enableManualVerification">{{ 'Printfiler godkänns manuellt' | translate }}</mat-checkbox>
                </div>
                <div class="col-4">
                    <mat-form-field class="fullwidth">
                        <label>{{ 'Minuter att fördröja nya ordrar' | translate }}</label>
                        <input matInput type="number" [(ngModel)]="globals.storeSettings.newOrderFreezeTimeMinutes" />
                    </mat-form-field>
                </div>
                <div class="col-4">
                    <mat-checkbox [(ngModel)]="globals.storeSettings.enablePrintCutOffTime">{{ 'Aktivera cut-off-tid klockan 23:00' | translate }}</mat-checkbox>
                </div>
            </div>
            <div class="row">
                <div class="col-4">
                    <mat-checkbox [(ngModel)]="globals.storeSettings.includeUnknownOrderItems">{{ 'Inkludera okända produkter' | translate }}</mat-checkbox>
                </div>
                <div class="col-4">
                    <mat-checkbox [(ngModel)]="globals.storeSettings.treatAllOrderItemsAsUnknown">{{ 'Behandla alla orderrader som okända' | translate }}</mat-checkbox>
                </div>
                <div class="col-4">
                    <mat-form-field>
                        <label>{{ 'SKU-transformerare' | translate }}</label>
                        <mat-select [(ngModel)]="globals.storeSettings.skuTransformer">
                            <mat-option [value]="null">{{ 'Ingen' | translate }}</mat-option>
                            <mat-option *ngFor="let transformer of availableSKUTransformers | keyvalue" [value]="transformer.key">
                                {{transformer.key}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>

            <br />

            <div>
                <h3>{{ 'Funktioner' | translate }}</h3>
                <div class="row">
                    <div class="col-auto">
                        <mat-checkbox [(ngModel)]="globals.storeSettings.enabledFeatures.tools">{{ 'Verktyg' | translate }}</mat-checkbox>
                    </div>

                    <div class="col-auto">
                        <mat-checkbox [(ngModel)]="globals.storeSettings.enabledFeatures.createOrder">{{ 'Skapa order' | translate }}</mat-checkbox>
                    </div>

                    <div class="col-auto">
                        <mat-checkbox [(ngModel)]="globals.storeSettings.enabledFeatures.generateBarcode">{{ 'Generera barcode' | translate }}</mat-checkbox>
                    </div>

                    <div class="col-auto">
                        <mat-checkbox [(ngModel)]="globals.storeSettings.enabledFeatures.testBarcode">{{ 'Testa barcode' | translate }}</mat-checkbox>
                    </div>
                </div>
                <br />
            </div>

            <h3>{{ 'Importerade tryckfiler' | translate }}</h3>
            <div class="row">
                <div class="col-4" *ngIf="globals.storeSettings.printFileImport.importAs == 'PRINT_FILE'">
                    <mat-form-field class="fullwidth">
                        <label>DPI</label>
                        <input matInput type="number" [(ngModel)]="globals.storeSettings.printFileImport.defaultDPI" />
                    </mat-form-field>
                </div>
                <div class="col-4" *ngIf="globals.storeSettings.printFileImport.importAs == 'PRINT_FILE'">
                    <mat-form-field class="fullwidth">
                        <label>{{ 'Utfall(mm)' | translate }}</label>
                        <input matInput type="number" [(ngModel)]="globals.storeSettings.printFileImport.defaultBleedMm" />
                    </mat-form-field>
                </div>
                <div class="col-4">
                    <mat-form-field>
                        <label>{{ 'Importera som' | translate }}</label>
                        <mat-select [(ngModel)]="globals.storeSettings.printFileImport.importAs">
                            <mat-option [value]="'PRINT_FILE'">{{ 'Printfil' | translate }}</mat-option>
                            <mat-option [value]="'POSTER'">{{ 'Poster' | translate }}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
            <br />
            <h3>{{ 'Exakta' | translate }}</h3>
            <div class="row">
                <div class="col-4">
                    <mat-form-field class="fullwidth">
                        <label>{{ 'Customer Name' | translate }}</label>
                        <input matInput type="text" [(ngModel)]="globals.storeSettings.exaktaSettings.customerName" />
                    </mat-form-field>
                </div>
                <div class="col-4">
                    <mat-form-field class="fullwidth">
                        <label>{{ 'Carrier alias' | translate }}</label>
                        <input matInput type="text" [(ngModel)]="globals.storeSettings.exaktaSettings.carrier" />
                    </mat-form-field>
                </div>
                <div class="col-4">
                    <mat-form-field class="fullwidth">
                        <label>{{ 'VOEC-nummer' | translate }}</label>
                        <input matInput type="text" [(ngModel)]="globals.storeSettings.voec" />
                    </mat-form-field>
                </div>
            </div>
        </mat-tab>

        <mat-tab [label]="'Integrationer' | translate">
            <br />
            <h3>{{ 'Shopify' | translate }}</h3>
            <div class="row">
                <div class="col-4"><mat-form-field class="fullwidth"><label>{{ 'Domain' | translate }}</label><input matInput type="text" [(ngModel)]="globals.storeSettings.shopifySettings.domain" /></mat-form-field></div>
                <div class="col-4"><mat-form-field class="fullwidth"><label>{{ 'Shop Name' | translate }}</label><input matInput type="text" [(ngModel)]="globals.storeSettings.shopifySettings.shopName" /></mat-form-field></div>
                <div class="col-4"><mat-form-field class="fullwidth"><label>{{ 'API Key' | translate }}</label><input matInput type="text" [(ngModel)]="globals.storeSettings.shopifySettings.apiKey" /></mat-form-field></div>
                <div class="col-4"><mat-form-field class="fullwidth"><label>{{ 'API Secret' | translate }}</label><input matInput type="text" [(ngModel)]="globals.storeSettings.shopifySettings.apiSecret" /></mat-form-field></div>
                <div class="col-4"><mat-form-field class="fullwidth"><label>{{ 'Access Token' | translate }}</label><input matInput type="text" [(ngModel)]="globals.storeSettings.shopifySettings.accessToken" /></mat-form-field></div>
            </div>

            <br />
            <h3>{{ 'Woocommerce' | translate }}</h3>
            <div class="row">
                <div class="col-4"><mat-form-field class="fullwidth"><label>{{ 'Site URL' | translate }}</label><input matInput type="text" [(ngModel)]="globals.storeSettings.woocommerceSettings.siteUrl" /></mat-form-field></div>
                <div class="col-4"><mat-form-field class="fullwidth"><label>{{ 'Consumer Key' | translate }}</label><input matInput type="text" [(ngModel)]="globals.storeSettings.woocommerceSettings.consumerKey" /></mat-form-field></div>
                <div class="col-4"><mat-form-field class="fullwidth"><label>{{ 'Consumer Secret' | translate }}</label><input matInput type="text" [(ngModel)]="globals.storeSettings.woocommerceSettings.consumerSecret" /></mat-form-field></div>
            </div>

            <br />
            <h3>{{ 'Fyndiq' | translate }}</h3>
            <div class="row">
                <div class="col-4"><mat-form-field class="fullwidth"><label>{{ 'Merchant ID' | translate }}</label><input matInput type="text" [(ngModel)]="globals.storeSettings.fyndiqSettings.merchantId" /></mat-form-field></div>
                <div class="col-4"><mat-form-field class="fullwidth"><label>{{ 'Token' | translate }}</label><input matInput type="text" [(ngModel)]="globals.storeSettings.fyndiqSettings.token" /></mat-form-field></div>
            </div>

            <br />
            <h3>{{ 'Klarna' | translate }}</h3>
            <div class="row">
                <div class="col-4"><mat-checkbox [(ngModel)]="globals.storeSettings.klarnaSettings.live">{{ 'Live' | translate }}</mat-checkbox></div>
                <div class="col-4"><mat-form-field class="fullwidth"><label>{{ 'Terms URL' | translate }}</label><input matInput type="text" [(ngModel)]="globals.storeSettings.klarnaSettings.termsUrl" /></mat-form-field></div>
                <div class="col-4"><mat-form-field class="fullwidth"><label>{{ 'Username' | translate }}</label><input matInput type="text" [(ngModel)]="globals.storeSettings.klarnaSettings.username" /></mat-form-field></div>
                <div class="col-4"><mat-form-field class="fullwidth"><label>{{ 'Password' | translate }}</label><input matInput type="text" [(ngModel)]="globals.storeSettings.klarnaSettings.password" /></mat-form-field></div>
            </div>

            <br />
            <h3>{{ 'Google Storage' | translate }}</h3>
            <div class="row">
                <div class="col-4"><mat-form-field class="fullwidth"><label>{{ 'Bucket Name' | translate }}</label><input matInput type="text" [(ngModel)]="globals.storeSettings.googleStorageSettings.bucketName" /></mat-form-field></div>
            </div>
        </mat-tab>

        <mat-tab label="Texprint">
            <br />
            <div class="row">
                <div class="col-4">
                    <mat-form-field class="fullwidth">
                        <label>{{ 'Varumärke' | translate }}</label>
                        <input matInput type="text" [(ngModel)]="globals.storeSettings.texPrintSettings.brand" />
                    </mat-form-field>
                </div>
                <div class="col-4">
                    <mat-form-field>
                        <label>{{ 'Shipping' | translate }}</label>
                        <mat-select [(ngModel)]="globals.storeSettings.texPrintSettings.shippingMethod">
                            <mat-option [value]="'regular'">
                                regular
                            </mat-option>
                            <mat-option [value]="'recorded'">
                                recorded
                            </mat-option>
                            <mat-option [value]="'courier'">
                                courier
                            </mat-option>
                            <mat-option [value]="'collection'">
                                collection
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
            <br />
        </mat-tab>

        <mat-tab [label]="'Epost' | translate">
            <br />
            <div class="row">
                <div class="col-4">
                    <mat-form-field class="fullwidth">
                        <label>{{ 'Sender name' | translate }}</label>
                        <input matInput type="text" [(ngModel)]="globals.storeSettings.emailSettings.sender.name" />
                    </mat-form-field>
                </div>
                <div class="col-4">
                    <mat-form-field class="fullwidth">
                        <label>{{ 'Sender address' | translate }}</label>
                        <input matInput type="text" [(ngModel)]="globals.storeSettings.emailSettings.sender.address" />
                    </mat-form-field>
                </div>
                <div class="col-4">
                    <mat-form-field class="fullwidth">
                        <label>{{ 'Header image url' | translate }}</label>
                        <input matInput type="text" [(ngModel)]="globals.storeSettings.emailSettings.headerImageUrl" />
                    </mat-form-field>
                </div>
                <div class="col-4">

                    <mat-checkbox [(ngModel)]="globals.storeSettings.emailSettings.hidePoweredByAce">{{ 'Dölj "Powered by Ace"' | translate }}</mat-checkbox>
                </div>
                <div class="col-4">
                    <mat-form-field class="fullwidth">
                        <label>{{ 'Spårningsmail extra HTML' | translate }}</label>
                        <textarea matInput
                            [(ngModel)]="globals.storeSettings.emailSettings.orderShippedEmailExtraContent"></textarea>
                    </mat-form-field>
                </div>
            </div>
            <br />
            <h3>{{ 'Test' | translate }}</h3>
            <div class="row">
                <div class="col-4">
                    <mat-form-field class="fullwidth">
                        <label>{{ 'Testadress' | translate }}</label>
                        <input matInput type="text" [(ngModel)]="testEmailAddress" />
                    </mat-form-field>
                </div>
                <div class="col-4">
                    <br />
                    <button mat-raised-button color="primary" (click)="testDispatchEmail()">{{ 'Spårningsmail testutskick' | translate }}</button>
                </div>
            </div>
        </mat-tab>

        <mat-tab [label]="'Standardpriser' | translate">
            <br />
            <div class="row" *ngIf="globals.storeSettings.defaultSizePrices">
                <div class="col-6">
                    <h3>{{ 'Standardpriser - Posters' | translate }}</h3>
                    <size-price-editor type="POSTER" [prices]="globals.storeSettings.defaultSizePrices.poster">
                    </size-price-editor>
                </div>
                <div class="col-6">
                    <h3>{{ 'Standardpriser - Canvas' | translate }}</h3>
                    <size-price-editor type="CANVAS" [prices]="globals.storeSettings.defaultSizePrices.canvas">
                    </size-price-editor>
                </div>
                <div class="col-12" *ngIf="globals.storeSettings.defaultSizePrices.frames">
                    <h3>{{ 'Standardpriser - Ramar' | translate }}</h3>

                    <div class="row">
                        <div class="col-4" *ngFor="let color of frameColors">
                            <h4>{{color}}</h4>
                            <div *ngFor="let size of globals.storeSettings.defaultSizePrices.frames | keyvalue">
                                <h5>{{size.key}}</h5>
                                <mat-form-field class="fullwidth">
                                    <input matInput type="number"
                                        [(ngModel)]="globals.storeSettings.defaultSizePrices.frames[size.key][color]" />
                                </mat-form-field>
                            </div>
                        </div>
                    </div>

                </div>
                <div class="col-6">
                    <h3>{{ 'Standardpriser - Tapet' | translate }}</h3>
                    <mat-form-field class="fullwidth">
                        <label>{{ 'Pris per kvm' | translate }}</label>
                        <input matInput type="number"
                            [(ngModel)]="globals.storeSettings.defaultSizePrices.wallpaper.squareMeterPrice" />
                    </mat-form-field>
                </div>
            </div>

            <ng-container *ngIf="globals.storeSettings.defaultSizePricesByCountry">
                <div class="row" *ngFor="let country of globals.storeSettings.defaultSizePricesByCountry | keyvalue">
                    <div class="col-12">
                        <h3>{{country.key.toUpperCase()}} ({{getCurrencyByCountry(country.key)}})</h3>
                    </div>
                    <div class="col-6">
                        <h3>{{ 'Standardpriser - Posters' | translate }}</h3>
                        <size-price-editor type="POSTER"
                            [prices]="globals.storeSettings.defaultSizePricesByCountry[country.key].poster">
                        </size-price-editor>
                    </div>
                    <div class="col-6">
                        <h3>{{ 'Standardpriser - Canvas' | translate }}</h3>
                        <size-price-editor type="CANVAS"
                            [prices]="globals.storeSettings.defaultSizePricesByCountry[country.key].canvas">
                        </size-price-editor>
                    </div>
                    <div class="col-12" *ngIf="globals.storeSettings.defaultSizePricesByCountry[country.key].frames">
                        <h3>{{ 'Standardpriser - Ramar' | translate }}</h3>

                        <div class="row">
                            <div class="col-4" *ngFor="let color of frameColors">
                                <h4>{{color}}</h4>
                                <div
                                    *ngFor="let size of globals.storeSettings.defaultSizePricesByCountry[country.key].frames | keyvalue">
                                    <h5>{{size.key}}</h5>
                                    <mat-form-field class="fullwidth">
                                        <input matInput type="number"
                                            [(ngModel)]="globals.storeSettings.defaultSizePricesByCountry[country.key].frames[size.key][color]" />
                                    </mat-form-field>
                                </div>
                            </div>
                        </div>

                    </div>
                    <div class="col-6">
                        <h3>{{ 'Standardpriser - Tapet' | translate }}</h3>
                        <mat-form-field class="fullwidth">
                            <label>{{ 'Pris per kvm' | translate }}</label>
                            <input matInput type="number"
                                [(ngModel)]="globals.storeSettings.defaultSizePricesByCountry[country.key].wallpaper.squareMeterPrice" />
                        </mat-form-field>
                    </div>
                </div>
            </ng-container>
        </mat-tab>

        <mat-tab label="Pictufy">
            <br />
            <div class="row">
                <div class="col-12">
                    <h3>{{ 'Pictufy' | translate }}</h3>
                </div>

                <div class="col-4">
                    <br />
                    <mat-checkbox [(ngModel)]="globals.storeSettings.pictufySettings.enabled">{{ 'Aktivera' | translate }}</mat-checkbox>
                </div>

                <div class="col-4">
                    <mat-form-field>
                        <mat-label>{{ 'Grade' | translate }}</mat-label>
                        <mat-select [(ngModel)]="globals.storeSettings.pictufySettings.grade">
                            <mat-option [value]="1">
                                1
                            </mat-option>
                            <mat-option [value]="2">
                                2
                            </mat-option>
                            <mat-option [value]="3">
                                3
                            </mat-option>
                            <mat-option [value]="4">
                                4
                            </mat-option>
                            <mat-option [value]="5">
                                5
                            </mat-option>
                            <mat-option [value]="6">
                                6
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>

                <div class="col-4">
                    <br />
                    <mat-checkbox [(ngModel)]="globals.storeSettings.pictufySettings.limitByType">{{ 'Begränsa per typ' | translate }}</mat-checkbox>
                </div>

                <div class="col-4" *ngIf="globals.storeSettings.pictufySettings.limitByType">
                    <br />
                    <mat-form-field>
                        <mat-label>{{ 'Typ' | translate }}</mat-label>
                        <mat-select multiple [(ngModel)]="globals.storeSettings.pictufySettings.artworkTypes">
                            <mat-option [value]="'photography'">{{ 'Photography' | translate }}</mat-option>
                            <mat-option [value]="'illustration'">{{ 'Illustration' | translate }}</mat-option>
                            <mat-option [value]="'wall_mural'">{{ 'Wall mural' | translate }}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>


                <div class="col-4">
                    <br />
                    <mat-checkbox [(ngModel)]="globals.storeSettings.pictufySettings.limitByGeometry">{{ 'Begränsa per geometri' | translate }}</mat-checkbox>
                </div>

                <div class="col-4" *ngIf="globals.storeSettings.pictufySettings.limitByGeometry">
                    <br />
                    <mat-form-field>
                        <mat-label>{{ 'Geometri' | translate }}</mat-label>
                        <mat-select multiple [(ngModel)]="globals.storeSettings.pictufySettings.geometries">
                            <mat-option [value]="'horizontal'">{{ 'Horizontal' | translate }}</mat-option>
                            <mat-option [value]="'vertical'">{{ 'Vertical' | translate }}</mat-option>
                            <mat-option [value]="'square'">{{ 'Square' | translate }}</mat-option>
                            <mat-option [value]="'panorama'">{{ 'Panorama' | translate }}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>

                <div class="col-4">
                    <br />
                    <mat-checkbox [(ngModel)]="globals.storeSettings.pictufySettings.limitByCollections">{{ 'Begränsa till kollektioner' | translate }}</mat-checkbox>
                </div>

                <div class="col-4">
                    <br />
                    <mat-checkbox [(ngModel)]="globals.storeSettings.pictufySettings.includeNudity">{{ 'Tillåt nudity' | translate }}</mat-checkbox>
                </div>

                <div class="col-4" *ngIf="globals.storeSettings.pictufySettings.limitByCollections">
                    <mat-form-field class="fullwidth">
                        <label>{{ 'Kollektions-IDn (kommaseparerad)' | translate }}</label>
                        <input matInput [(ngModel)]="pictufyCollections">
                    </mat-form-field>
                </div>

                <div class="col-4" *ngIf="globals.storeSettings.pictufySettings.lists">
                    <mat-form-field class="fullwidth">
                        <label>{{ 'List-IDn (kommaseparerad)' | translate }}</label>
                        <input matInput [(ngModel)]="pictufyLists">
                    </mat-form-field>
                </div>

                <div class="col-12">
                    <br />

                    <div class="row">
                        <div class="col">
                            <mat-checkbox [(ngModel)]="globals.storeSettings.pictufySettings.mockupImageFilter.enabled">{{ 'Specificera mockupbilder' | translate }}</mat-checkbox>
                        </div>
                        <div class="col">
                            <mat-checkbox [(ngModel)]="globals.storeSettings.pictufySettings.mockupImageFilter.useMockupsBySize">{{ 'Välj automatiskt från storlek' | translate }}</mat-checkbox>
                        </div>
                    </div>


                    <div class="row"
                        *ngIf="this.globals.storeSettings.pictufySettings.mockupImageFilter.enabled && !this.globals.storeSettings.pictufySettings.mockupImageFilter.useMockupsBySize">
                        <div class="col-6">

                            <mat-form-field class="fullwidth">
                                <mat-label>{{ 'Mockup IDn' | translate }}</mat-label>
                                <mat-chip-grid #mockupIds>
                                    <mat-chip *ngFor="let id of globals.storeSettings.pictufySettings.mockupImageFilter.ids"
                                        [removable]="true" (remove)="removePictufyMockupId(id)">
                                        {{id}}
                                        <span class="material-symbols-outlined" matChipRemove (click)="removePictufyMockupId(id)">cancel
                                        </span>
                                    </mat-chip>
                                    <input [placeholder]="'Lägg till..' | translate" [matChipInputFor]="mockupIds" [matChipInputAddOnBlur]="true"
                                        (matChipInputTokenEnd)="addPictufyMockupId($event)">
                                </mat-chip-grid>
                            </mat-form-field>
                        </div>
                        <div class="col-6">
                            <h5>{{ 'Per lista' | translate }}</h5>
                            <div *ngFor="let list of globals.storeSettings.pictufySettings.lists">
                                <div>{{list}}</div>
                                <mat-form-field class="fullwidth">
                                    <mat-label>{{ 'Mockup IDn' | translate }}</mat-label>
                                    <mat-chip-grid #mockupListIds>
                                        <mat-chip
                                            *ngFor="let id of pictufyListMockupIds(list)"
                                            [removable]="true" (remove)="removePictufyListMockupId(list, id)">
                                            {{id}}
                                            <span class="material-symbols-outlined" matChipRemove
                                                (click)="removePictufyListMockupId(list, id)">cancel
                                            </span>
                                        </mat-chip>
                                        <input [placeholder]="'Lägg till..' | translate" [matChipInputFor]="mockupListIds" [matChipInputAddOnBlur]="true"
                                            (matChipInputTokenEnd)="addPictufyListMockupId(list, $event)">
                                    </mat-chip-grid>
                                </mat-form-field>
                            </div>
                        </div>
                    </div>
                </div>


                <div class="col-12">
                    <br />
                    <br />
                    <h5>{{ 'Produkter' | translate }}</h5>
                    <div class="row">


                        <div class="col-4">
                            <mat-form-field class="fullwidth">
                                <label>{{ 'Produkter att skapa per batch' | translate }}</label>
                                <input type="number" matInput [(ngModel)]="globals.storeSettings.pictufySettings.productsInBatch">
                            </mat-form-field>
                        </div>


                        <div class="col-4">
                            <br />
                            <mat-checkbox [(ngModel)]="globals.storeSettings.pictufySettings.createWallpaperProducts">{{ 'Skapa tapetprodukter i Shopify' | translate }}</mat-checkbox>
                        </div>

                        <div class="col-4">
                            <br />
                            <mat-checkbox [(ngModel)]="globals.storeSettings.pictufySettings.createShopifyCollections">{{ 'Skapa produktserier i Shopify' | translate }}</mat-checkbox>
                        </div>

                        <div class="col-4">
                            <h4>{{ 'Storlekar att skapa i Shopify' | translate }}</h4>
                            <br />

                            <h5>{{ 'Canvas' | translate }}</h5>
                            <ng-container *ngFor="let size of availableCanvasSizes">
                                <mat-checkbox [(ngModel)]="globals.storeSettings.pictufySettings.canvasSizesToCreate[size]">
                                    {{size}}
                                </mat-checkbox>
                            </ng-container>
                            <br />

                            <h5>{{ 'Poster' | translate }}</h5>
                            <ng-container *ngFor="let size of availablePosterSizes">
                                <mat-checkbox [(ngModel)]="globals.storeSettings.pictufySettings.posterSizesToCreate[size]">
                                    {{size}}
                                </mat-checkbox>
                            </ng-container>

                        </div>



                        <div class="col-4">
                            <br />
                            <mat-checkbox [(ngModel)]="globals.storeSettings.pictufySettings.generateDescriptionFromPrompt">{{ 'Generera produktbeskrivning från prompt' | translate }}</mat-checkbox>
                        </div>

                        <div class="col-4" *ngIf="globals.storeSettings.pictufySettings.generateDescriptionFromPrompt">
                            <br />
                            <mat-form-field class="fullwidth">
                                <label>{{ 'Prompt' | translate }}</label>
                                <textarea matInput [(ngModel)]="globals.storeSettings.pictufySettings.descriptionPrompt"></textarea>
                            </mat-form-field>
                        </div>

                        <div class="col-12">
                            <br />
                            <h4>{{ 'Taggkategorier' | translate }}<span class="material-symbols-outlined clickable" (click)="addTagCategory()">add</span>
                            </h4>
                            <div class="row" *ngFor="let tagCategory of globals.storeSettings.pictufySettings.tagCategories">
                                <div class="col">
                                    <mat-form-field class="fullwidth">
                                        <label>{{ 'Namn' | translate }}</label>
                                        <textarea matInput [(ngModel)]="tagCategory.name"></textarea>
                                    </mat-form-field>
                                </div>
                                <div class="col">
                                    <mat-form-field class="fullwidth">
                                        <label>{{ 'Taggar' | translate }}</label>
                                        <textarea matInput [(ngModel)]="tagCategory.tags"></textarea>
                                    </mat-form-field>
                                </div>
                                <div class="col align-right">
                                    <span class="material-symbols-outlined clickable"
                                        (click)="removeTagCategory(tagCategory)">remove</span>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>

            </div>
        </mat-tab>

        <mat-tab *ngIf="globals.userIsAce()" [label]="'Krediter' | translate">
            <br />
            <div class="row">
                <div class="col-4">
                    <mat-form-field class="fullwidth">
                        <label>{{ 'Krediter att fylla på' | translate }}</label>
                        <input type="number" matInput [(ngModel)]="creditsToAdd">
                    </mat-form-field>

                    <button mat-raised-button color="primary" (click)="addCredits()">{{ 'Fyll på' | translate }}</button>
                </div>
                <div class="col-4">
                    <mat-checkbox [(ngModel)]="globals.storeSettings.allowNegativeCredits">{{ 'Tillåt negativa krediter' | translate }}</mat-checkbox>
                </div>
            </div>

        </mat-tab>

        <mat-tab [label]="'Avgifter' | translate" *ngIf="globals.storeSettings.creditPrices">
            <br />
            <mat-tab-group>
                <mat-tab [label]="'Generellt' | translate">
                    <br />
                    <table class="styled fullwidth">
                        <tr>
                            <th>SKU</th>
                            <th>{{ 'Pris' | translate }}</th>
                            <th>{{ 'Följandepris' | translate }}</th>
                            <th>{{ 'Emballage/frakt' | translate }}</th>
                        </tr>
                        <tr *ngFor="let sku of availableExaktaSKUs">
                            <ng-container *ngIf="globals.storeSettings.creditPrices[sku]">
                                <td>
                                    {{sku}}
                                </td>
                                <td>
                                    <mat-form-field class="">
                                        <input type="number" matInput [(ngModel)]="globals.storeSettings.creditPrices[sku].printPrice">
                                    </mat-form-field>
                                </td>
                                <td>
                                    <mat-form-field class="">
                                        <input type="number" matInput [(ngModel)]="globals.storeSettings.creditPrices[sku].additionalPrice">
                                    </mat-form-field>
                                </td>
                                <td>
                                    <mat-form-field class="">
                                        <input type="number" matInput [(ngModel)]="globals.storeSettings.creditPrices[sku].shippingPrice">
                                    </mat-form-field>
                                </td>
                                <td>

                                </td>
                            </ng-container>
                        </tr>
                    </table>
                </mat-tab>

                <mat-tab *ngFor="let country of globals.storeSettings.countrySpecificShippingPrices | keyvalue"
                    label="{{country.key.toUpperCase()}}">
                    <br />
                    <table class="styled fullwidth">
                        <tr>
                            <th>SKU</th>
                            <th>{{ 'Emballage/frakt' | translate }}</th>
                        </tr>
                        <tr *ngFor="let sku of availableExaktaSKUs">
                            <ng-container *ngIf="country.value[sku]">
                                <td>
                                    {{sku}}
                                </td>
                                <td>
                                    <mat-form-field class="">
                                        <input type="number" matInput [(ngModel)]="country.value[sku].shippingPrice">
                                    </mat-form-field>
                                </td>
                                <td>

                                </td>
                            </ng-container>
                        </tr>
                    </table>
                </mat-tab>
            </mat-tab-group>

        </mat-tab>

        <mat-tab #cloneTab [label]="'Klona butik' | translate">
            <br />
            <p>{{ 'Skapar en ny butik som en kopia av den här. Fält som måste vara unika per butik är tomma eller föreslagna – kontrollera dem innan du klonar. Den här butiken ändras inte.' | translate }}</p>

            <div *ngIf="cloneSettings">
                <h3>{{ 'Generellt' | translate }}</h3>
                <div class="row">
                    <div class="col-4">
                        <mat-form-field class="fullwidth">
                            <label>{{ 'Namn' | translate }}</label>
                            <input matInput type="text" [(ngModel)]="cloneSettings.name" (ngModelChange)="cloneNameChanged()" />
                        </mat-form-field>
                    </div>
                    <div class="col-4">
                        <mat-form-field class="fullwidth">
                            <label>{{ 'Varumärke' | translate }}</label>
                            <input matInput type="text" [(ngModel)]="cloneSettings.brandName" />
                        </mat-form-field>
                    </div>
                    <div class="col-4">
                        <mat-form-field class="fullwidth">
                            <label>{{ 'Access Code' | translate }}</label>
                            <input matInput type="text" [(ngModel)]="cloneSettings.accessCode"
                                [placeholder]="'Genereras automatiskt om tom' | translate" />
                        </mat-form-field>
                    </div>
                    <div class="col-4">
                        <mat-form-field>
                            <label>{{ 'Platform' | translate }}</label>
                            <mat-select [(ngModel)]="cloneSettings.platform">
                                <mat-option [value]="'woocommerce'">woocommerce</mat-option>
                                <mat-option [value]="'shopify'">shopify</mat-option>
                                <mat-option [value]="'fyndiq'">fyndiq</mat-option>
                                <mat-option [value]="'order-gateway'">{{ 'order-gateway' | translate }}</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="col-4">
                        <mat-form-field>
                            <label>{{ 'Type' | translate }}</label>
                            <mat-select [(ngModel)]="cloneSettings.type">
                                <mat-option [value]="'ace'">ace</mat-option>
                                <mat-option [value]="'partner'">partner</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="col-4">
                        <mat-form-field class="fullwidth">
                            <label>{{ 'Order Number Prefix' | translate }}</label>
                            <input matInput type="text" [(ngModel)]="cloneSettings.orderNumberPrefix" />
                        </mat-form-field>
                    </div>
                    <div class="col-4">
                        <mat-form-field class="fullwidth">
                            <label>{{ 'Epost' | translate }}</label>
                            <input matInput type="text" [(ngModel)]="cloneSettings.email" />
                        </mat-form-field>
                    </div>
                    <div class="col-4">
                        <mat-form-field class="fullwidth">
                            <label>{{ 'Admin Email' | translate }}</label>
                            <input matInput type="text" [(ngModel)]="cloneSettings.adminEmail" />
                        </mat-form-field>
                    </div>
                    <div class="col-4">
                        <mat-form-field class="fullwidth">
                            <label>{{ 'Custom Gateway Domain' | translate }}</label>
                            <input matInput type="text" [(ngModel)]="cloneSettings.customOrderGatewayDomain" />
                        </mat-form-field>
                    </div>
                </div>
                <div class="row">
                    <div class="col-4">
                        <mat-checkbox [(ngModel)]="cloneSettings.disabled">{{ 'Inaktiverad' | translate }}</mat-checkbox>
                    </div>
                    <div class="col-4">
                        <mat-checkbox [(ngModel)]="cloneSettings.sandbox">{{ 'Sandbox' | translate }}</mat-checkbox>
                    </div>
                    <div class="col-4">
                        <mat-checkbox [(ngModel)]="cloneSettings.onboardingPending">{{ 'Onboarding Pending' | translate }}</mat-checkbox>
                    </div>
                </div>

                <br />
                <h3>{{ 'Exakta' | translate }}</h3>
                <div class="row">
                    <div class="col-4">
                        <mat-form-field class="fullwidth">
                            <label>{{ 'Customer Name' | translate }}</label>
                            <input matInput type="text" [(ngModel)]="cloneSettings.exaktaSettings.customerName"
                                [disabled]="syncCloneNames" />
                        </mat-form-field>
                    </div>
                    <div class="col-4">
                        <mat-form-field class="fullwidth">
                            <label>{{ 'FTP-rotmapp' | translate }}</label>
                            <input matInput type="text" [(ngModel)]="cloneSettings.exaktaSettings.ftpSettings.rootFolder"
                                [disabled]="syncCloneNames" />
                        </mat-form-field>
                    </div>
                    <div class="col-4">
                        <mat-checkbox [(ngModel)]="syncCloneNames" (ngModelChange)="cloneNameChanged()">{{ 'Följ butiksnamnet' | translate }}</mat-checkbox>
                    </div>
                </div>

                <br />
                <h3>{{ 'Integrationer' | translate }}</h3>
                <div class="row">
                    <div class="col-4">
                        <mat-form-field class="fullwidth">
                            <label>{{ 'Shopify' | translate }} - {{ 'Domain' | translate }}</label>
                            <input matInput type="text" [(ngModel)]="cloneSettings.shopifySettings.domain" />
                        </mat-form-field>
                    </div>
                    <div class="col-4">
                        <mat-form-field class="fullwidth">
                            <label>{{ 'Shopify' | translate }} - {{ 'Shop Name' | translate }}</label>
                            <input matInput type="text" [(ngModel)]="cloneSettings.shopifySettings.shopName" />
                        </mat-form-field>
                    </div>
                    <div class="col-4">
                        <mat-form-field class="fullwidth">
                            <label>{{ 'Shopify' | translate }} - {{ 'Access Token' | translate }}</label>
                            <input matInput type="text" [(ngModel)]="cloneSettings.shopifySettings.accessToken" />
                        </mat-form-field>
                    </div>
                    <div class="col-4">
                        <mat-form-field class="fullwidth">
                            <label>{{ 'Woocommerce' | translate }} - {{ 'Site URL' | translate }}</label>
                            <input matInput type="text" [(ngModel)]="cloneSettings.woocommerceSettings.siteUrl" />
                        </mat-form-field>
                    </div>
                    <div class="col-4">
                        <mat-form-field class="fullwidth">
                            <label>{{ 'Google Storage' | translate }} - {{ 'Bucket Name' | translate }}</label>
                            <input matInput type="text" [(ngModel)]="cloneSettings.googleStorageSettings.bucketName" />
                        </mat-form-field>
                    </div>
                </div>

                <br />
                <h3>{{ 'Epost' | translate }}</h3>
                <div class="row">
                    <div class="col-4">
                        <mat-form-field class="fullwidth">
                            <label>{{ 'Sender name' | translate }}</label>
                            <input matInput type="text" [(ngModel)]="cloneSettings.emailSettings.sender.name" />
                        </mat-form-field>
                    </div>
                    <div class="col-4">
                        <mat-form-field class="fullwidth">
                            <label>{{ 'Sender address' | translate }}</label>
                            <input matInput type="text" [(ngModel)]="cloneSettings.emailSettings.sender.address" />
                        </mat-form-field>
                    </div>
                </div>

                <br />
                <h3>{{ 'Kopiera med' | translate }}</h3>
                <div class="row">
                    <div class="col-auto">
                        <mat-checkbox [(ngModel)]="cloneOptions.prices">{{ 'Priser och avgifter' | translate }}</mat-checkbox>
                    </div>
                    <div class="col-auto">
                        <mat-checkbox [(ngModel)]="cloneOptions.pictufySettings">{{ 'Pictufy-inställningar' | translate }}</mat-checkbox>
                    </div>
                    <div class="col-auto">
                        <mat-checkbox [(ngModel)]="cloneOptions.initFtp">{{ 'Skapa FTP-mappar' | translate }}</mat-checkbox>
                    </div>
                </div>
                <p>{{ 'Övriga inställningar kopieras alltid. Den nya butiken börjar utan krediter.' | translate }}</p>

                <div class="row" *ngIf="cloneError">
                    <div class="col">
                        <p class="negative-foreground">{{cloneError}}</p>
                    </div>
                </div>

                <div class="row" *ngIf="clonedStore">
                    <div class="col">
                        <p>{{ 'Butiken klonades!' | translate }} <strong>{{clonedStore.name}}</strong></p>
                        <button mat-raised-button color="primary" (click)="openClonedStore()">{{ 'Öppna den nya butiken' | translate }}</button>
                    </div>
                </div>

                <br />
                <div class="row">
                    <div class="col align-right">
                        <button mat-raised-button (click)="resetCloneForm()" style="margin-right: 15px;">{{ 'Återställ' | translate }}</button>
                        <button mat-raised-button color="primary" [disabled]="cloning" (click)="cloneStore()">
                            {{ (cloning ? 'Klonar...' : 'Klona butik') | translate }}
                        </button>
                    </div>
                </div>
            </div>
            <br />
        </mat-tab>

    </mat-tab-group>

    <div class="row" *ngIf="!cloneTabActive">
        <div class="col align-right">
            <button *ngIf="globals.userIsAce()" mat-raised-button color="accent" (click)="importPrices()" style="margin-right: 15px;">{{ 'Importera priser' | translate }}</button>
            <button mat-raised-button color="primary" (click)="save()">{{ 'Spara' | translate }}</button>
        </div>
    </div>
</div>